import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-command-system-changes',
  templateUrl: './command-system-changes.component.html',
  styleUrls: ['./command-system-changes.component.scss'],
})
export class CommandSystemChangesComponent {

  constructor(
    private readonly dialogRef: MatDialogRef<CommandSystemChangesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { header: string; changesList: string[] }
  ) { }

  close(): void {
    this.dialogRef.close();
  }

  getChangeKey(change: string): string {
    const index = change.indexOf(':');
    return index > -1 ? change.slice(0, index) : change;
  }

  getChangeValue(change: string): string {
    const index = change.indexOf(':');
    return index > -1 ? change.slice(index + 1).trim() : '';
  }
}
